import { Link } from 'react-router-dom';

import { footerLinks } from './nav-items';

/**
 * Public site footer: copyright + legal links. Social icons were removed
 * 2026-05-31 per design feedback.
 */
export function Footer() {
  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-1 px-4 py-4 sm:px-6 min-[601px]:flex-row min-[601px]:justify-between">
        <p className="text-sm text-muted-foreground">© 2026 Yaarikut</p>

        <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {footerLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="text-sm text-muted-foreground transition-colors hover:text-ink"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
